import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthShell, { googleLogin } from "../components/AuthShell";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const input = "w-full border border-linen bg-white px-4 py-3 text-sm outline-none focus:border-pitch transition-colors";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const dest = location.state?.from || "/account";

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      navigate(u.role === "admin" ? "/admin" : dest);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign In" subtitle="Welcome back"
      footer={<>New to LUXYREIGN? <Link to="/register" className="text-pitch border-b border-pitch pb-0.5">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        {error && <div className="bg-vermilion/10 border border-vermilion/30 text-vermilion text-sm px-4 py-3" data-testid="login-error">{error}</div>}
        <input required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="login-email" />
        <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="login-password" />
        <div className="text-right"><Link to="/forgot-password" className="text-xs text-stonemuted hover:text-pitch">Forgot password?</Link></div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors disabled:opacity-50">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <div className="flex items-center gap-4 my-6"><span className="flex-1 h-px bg-linen" /><span className="text-xs text-stonemuted uppercase tracking-widest">or</span><span className="flex-1 h-px bg-linen" /></div>
      <button onClick={googleLogin} data-testid="login-google"
        className="w-full border border-pitch text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-pitch hover:text-ivory transition-colors">Continue with Google</button>
    </AuthShell>
  );
}
